import { render, staticRenderFns } from "./SquatationView.vue?vue&type=template&id=6b8d8c62&scoped=true"
import script from "./SquatationView.vue?vue&type=script&lang=js"
export * from "./SquatationView.vue?vue&type=script&lang=js"
import style0 from "./SquatationView.vue?vue&type=style&index=0&id=6b8d8c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8d8c62",
  null
  
)

export default component.exports